//@flow
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose, withProps, lifecycle } from 'recompose'
import { isLoggedIn, isSessionLoaded, isEmailVerified } from '../session'
import { confirmEmail } from './actions'
import { isConfirmInProgress } from './selectors'
import withLoadingUntilProps from '../../core/withLoadingUntilProps'
import withErrorIfProps from '../../core/withErrorIfProps'
import Loading from '../../ui/views/loading'

const mapStateToProps = state => ({
  isSessionLoaded: isSessionLoaded(state),
  isLoggedIn: isLoggedIn(state),
  isEmailVerified: isEmailVerified(state),
  isVerifying: isConfirmInProgress(state)
})

const mapDispatchToProps = {
  confirmEmail
}

const withDataAndActionCreator = connect(mapStateToProps, mapDispatchToProps)

const withTokenFromUrl = withProps(routerProps => {
  const token = routerProps.match.params.token
  return {
    token
  }
})

const verifyOnMount = lifecycle({
  verifyEmail() {
    const {
      isVerifying,
      isEmailVerified,
      confirmEmail,
      token,
      history
    } = this.props
    if (isVerifying) {
      return
    }
    if (!isEmailVerified && !isVerifying) {
      confirmEmail(token).then(res => {
        console.log('confirm email result', res)
        const destination = res ? '/verify-success' : '/verify-failed'
        console.log('Confirmation finished destination', destination)
        history.replace(destination)
      })
    }
  },
  ensureUserIsLoggedIn() {
    const {
      isSessionLoaded,
      isLoggedIn,
      history,
      location,
      isEmailVerified
    } = this.props
    if (isSessionLoaded && !isLoggedIn) {
      console.log('User not logged in!')
      history.replace('/login', { returnUrl: location.pathname })
      return false
    }
    if (isSessionLoaded && !!isEmailVerified) {
      console.log('User has already verified email!')
      history.replace('/explore')
      return false
    }
    return true
  },
  componentDidMount() {
    this.ensureUserIsLoggedIn() && this.verifyEmail()
  },
  componentDidUpdate() {
    //this.ensureUserIsLoggedIn() && this.verifyEmail()
    this.ensureUserIsLoggedIn() && this.verifyEmail()
  }
})

export default compose(
  withRouter,
  withTokenFromUrl,
  withErrorIfProps(props => !props.token),
  withDataAndActionCreator,
  withLoadingUntilProps('isSessionLoaded'),
  verifyOnMount
)(Loading)



// WEBPACK FOOTER //
// ./src/services/email-verification/VerifyEmail.js